
import { GuardrailsRepository } from '../repositories/GuardrailsRepository';

export class GuardrailsService {
  private repository: GuardrailsRepository;

  constructor() {
    this.repository = GuardrailsRepository.getInstance();
  }

  /**
   * Get all models
   */
  public async applyGuardrails(config: any): Promise<any> {
    return await this.repository.applyGuardrails(config);
  }

  public async updateGuardrails(config: any): Promise<any> {
    return await this.repository.updateGuardrails(config);
  }

  public async getGuardrailForDeployedInstance(instanceId: string): Promise<any> {
    return await this.repository.getGuardrailForDeployedInstance(instanceId);
  }

  public async getAllGuardrails(): Promise<any[]> {
    return await this.repository.getAllGuardrails();
  }

  public async getGuardrailById(id: string): Promise<any> {
    return await this.repository.getGuardrailById(id);
  }

  public async deleteGuardrailById(id: string): Promise<void> {
    return await this.repository.deleteGuardrailById(id);
  }
}

// Export singleton instance
export const guardrailsService = new GuardrailsService();
